// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Formats.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Formats components
 */

import React from 'react';
import FieldDetail from 'modules/ReportDesigner/Fields/Izenda.FieldDetail';
import FormatTree from './Izenda.FormatsTree';
import DnDFormatsConfig from './Izenda.DnDFormatsConfig';
import Constants from 'logic/data/Izenda.ReportDesignerConstants';

export default {
  /**
   * Update store
   * @param {Object} store 
   */
  setStore(store: any): void {
    this.store = store.fieldsStore;
  },

  /** 
   * Destroy store
  */
  destroy(): void {
    delete this['store'];
  },

  /** 
   * Reload view
   * @returns {Object}
  */
  reloadView(): any {
    this.isReloadView = true;
    return this.store.loadInitial();
  },

  /** 
   * Render middle panel
   * @returns {Object}
  */
  renderMiddlePanel(): any {
    return <FormatTree store={this.store} uiStore={DnDFormatsConfig.sourceOptions} />;
  },

  /** 
   * Render main content
   * @param {String|(com: any) => void} ref
   * @returns {Object}
  */
  renderMainContent(ref: string|(com: any) => void, updateResultsInfo: any): any {
    return (
      <FieldDetail
        ref={ref}
        updateResultInfo={updateResultsInfo}
        store={this.store}
        uiStore={DnDFormatsConfig.targetOptions}
        isReloadView={this.isReloadView}
        pageName={Constants.PAGE_NAME.FORMATS}
      />
    );
  }
};



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Formats/Izenda.Formats.js